import type { AxiosInstance } from 'axios';
import type {
  DocumentTypeResponse,
  DocumentTypeListQueryParams,
  DocumentTypeCreateRequest,
  DocumentTypeUpdateRequest,
  EntityId,
} from '@/types';

export const getDocumentTypes = async (
  api: AxiosInstance,
  limit = 50,
  offset = 0,
): Promise<DocumentTypeResponse[]> => {
  const resp = await api.get<DocumentTypeResponse[]>('/document/type', {
    params: { limit, offset } as DocumentTypeListQueryParams,
  });
  return resp.data;
};

export const getDocumentType = async (
  api: AxiosInstance,
  document_type_id: EntityId,
): Promise<DocumentTypeResponse> => {
  const resp = await api.get<DocumentTypeResponse>(
    `/document/type/${document_type_id}`,
  );
  return resp.data;
};

export const createDocumentType = async (
  api: AxiosInstance,
  values: DocumentTypeCreateRequest,
): Promise<DocumentTypeResponse> => {
  const resp = await api.post<DocumentTypeResponse>(`/document/type/`, values);
  return resp.data;
};

export const updateDocumentType = async (
  api: AxiosInstance,
  document_type_id: EntityId,
  values: DocumentTypeUpdateRequest,
): Promise<DocumentTypeResponse> => {
  const resp = await api.put<DocumentTypeResponse>(
    `/document/type/${document_type_id}`,
    values,
  );
  return resp.data;
};

export const deleteDocumentType = async (
  api: AxiosInstance,
  document_id: EntityId,
): Promise<void> => {
  const resp = await api.delete(`/document/type/${document_id}`);
  return resp.data;
};

